import React from 'react';

const ProtectedRoute = ({ children }) => {
  // Bypass authentication for now - always allow access
  return children;
};

export default ProtectedRoute;